import React, { useState, memo, useCallback } from "react"
import Link from "./link"
import { GatsbyImage } from "gatsby-plugin-image"
import VideoPlayer from "./videoPlayer"
import ConditionallyRender from "./utils/conditionallyRender"
import copyWright from "../util/copyright"

const ProjectCard = ({ project, ratio, loading = 'lazy' }) => {


  return (
    <Link className='link' to={"/projects/" + project.slug} >
      <HoverWrapper project={project} ratio={ratio} loading={loading} />
    </Link >
  )
}

const HoverWrapper = ({ project, ratio, loading }) => {
  const [showSecondaryMedia, setShowSecondaryMedia] = useState(false)

  const changeMedia = useCallback((flag) => {
    if (project.hoverVideoUrl || project.hoverImage) {
      setShowSecondaryMedia(flag)
    }
  }, [project.hoverVideoUrl, project.hoverImage])

  return (
    <div className='single--project-card' onMouseEnter={() => changeMedia(true)} onMouseLeave={() => changeMedia(false)} role='presentation'>
      <div className={'pos-rel bg-dark overflow-hidden ' + (ratio ? ratio : 'ratio-1-2')} style={{ background: project.projectColor?.hex }}>
        <div style={{ opacity: showSecondaryMedia ? 0 : 1 }}>
          <Media project={project} loading={loading} />
        </div>
        < div style={{ opacity: showSecondaryMedia ? 1 : 0 }}>
          <ConditionallyRender when={(project.hoverVideoUrl || project.hoverImage)}>
            <Media secondary={true} project={project} loading={loading} />
          </ConditionallyRender>
        </div>
      </div>
      <Info project={project} />
    </div>)
}


const Media = memo(({ project, secondary = false, loading }) => {
  const indiactor = (secondary ? project.hoverVideoUrl : project.featuredVideo)

  const video = indiactor
  const image = (secondary ? project.hoverImage : project.featuredImage)

  if (indiactor) {
    return (
      <div className="bg-image video-wrapper">
        <VideoPlayer url={video} />
      </div>
    )
  }

  return (
    <GatsbyImage outputPixelDensities={1.5} quality={30} loading={loading} imgStyle={{ height: '102%' }} className='bg-image' image={image?.gatsbyImageData} alt="" />
  )

})

const Info = memo(({ project }) => {
  return (
    <div className="information flex mt10">
      <div className="w-50 mla uppercase">
        <p className='m0 lh-08 text-light'>{project.name}</p>
        <p className='m0 lh-08 text-light'>{project.scope}</p>
        <p className='m0 lh-08 text-normal'>{copyWright(project.year)} </p>
      </div>
    </div>
  )
})



export default ProjectCard
